export default __webpack_public_path__ + "static/media/DateWiseInterview.d003d408.svg";